export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/list-view-icon.bf14b655.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};